/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Locate the product JSON for the product the page is actually about.
 *
 * `[data-product-json]` is not unique: the mini cart renders one per upsell
 * panel (snippets/mini-cart-upsells--panels.liquid) and, because the header
 * comes before <main> in the document, those win a plain
 * `document.querySelector`. They also use a different shape (a bare product
 * object rather than `{ product: ... }`), so picking one up left
 * `window.productData.product` undefined and broke everything that depends on
 * it - most visibly the PDP stock message, which then fell back to "Sold Out".
 */
function getProductJsonScript() {
  var scripts = document.querySelectorAll('script[data-product-json]');

  for (var i = 0; i < scripts.length; i++) {
    if (!scripts[i].closest('#mini-cart, .product-upsell__panel')) {
      return scripts[i];
    }
  }

  return null;
}

/**
 * The section that owns the product this page is about.
 *
 * Variant-selector markup is not unique to the product page either: the mini cart
 * renders a full set of `.product-form__single-selector` swatches per upsell panel,
 * in the header - i.e. ahead of <main> in the document. Any document-wide lookup for
 * a selector therefore risks picking up an upsell product's controls instead of this
 * product's, so everything that reasons about the selected variant is scoped here.
 */
function getProductScope() {
  var script = getProductJsonScript();
  var scope = script && script.closest('[data-section-type]');

  return scope || document;
}

// product tabs
document.addEventListener('DOMContentLoaded', function () {
  // Step 1: Parse product variants data from JSON and log for testing
  var productJsonScript = getProductJsonScript();
  if (productJsonScript) {
    try {
      var productData = JSON.parse(productJsonScript.textContent);
      if (!productData || !productData.product) {
        throw new Error('Unexpected product JSON shape');
      }
      window.productData = productData; // Make globally accessible
      var variants = productData.product.variants;
      if (document.querySelector('[data-dev-mode]')) {
        console.warn('---Dev Mode Logging---');
        console.log('[Step 1 Test] Product variants:', variants);
      }
    } catch (e) {
      if (document.querySelector('[data-dev-mode]')) {
        console.warn('---Dev Mode Logging---');
        console.error('Failed to parse product JSON:', e);
      }
    }
  } else {
    if (document.querySelector('[data-dev-mode]')) {
      console.warn('---Dev Mode Logging---');
      console.log('No product JSON found on page.');
    }
  }

  document.querySelectorAll('.product-block-list__tabs_navigation a').forEach(function (tabLink) {
    tabLink.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      // Remove the selected class from all tabs
      document
        .querySelector('.product-block-list__tabs_navigation a.selected')
        ?.classList.remove('selected');

      // Hide all tab contents
      document.querySelectorAll('.product-block-list__tab').forEach(function (tabContent) {
        tabContent.style.display = 'none';
      });

      // Add selected class to the clicked tab
      tabLink.classList.add('selected');

      // Show the corresponding tab content
      document.querySelector(tabLink.getAttribute('href')).style.display = 'block';
    });
  });

  document.querySelector('.product-tab--description')?.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    // Get the first tab link
    var firstTabLink = document.querySelector(
      '.product-block-list__tabs_navigation ul li:first-child a'
    );

    // Remove the selected class from all tabs
    document
      .querySelector('.product-block-list__tabs_navigation a.selected')
      ?.classList.remove('selected');

    // Hide all tab contents
    document.querySelectorAll('.product-block-list__tab').forEach(function (tabContent) {
      tabContent.style.display = 'none';
    });

    // Add selected class to the first tab
    firstTabLink.classList.add('selected');

    // Show the corresponding tab content
    document.querySelector(firstTabLink.getAttribute('href')).style.display = 'block';

    // Scroll to the product description
    window.scrollTo(0, document.getElementById('product-description').offsetTop);
  });

  // Step 4: Refactor custom dropdown rendering so it can be called externally
  document.querySelectorAll('.custom-variant-dropdown').forEach(function (dropdownWrapper) {
    var optionName = dropdownWrapper.getAttribute('data-for');
    var select = document.querySelector('select[name="' + optionName + '"]');
    if (!select) return;

    // Store the initial width to prevent changes on variant updates
    var initialWidth = null;
    // Track if this is the initial page load

    // Attach the render function to the select for external calls
    select.renderCustomDropdown = function () {
      // Clear the placeholder and create the real dropdown
      dropdownWrapper.innerHTML = '';
      var selectedValue = select.value;
      var options = Array.from(select.options);
      var dropdown = document.createElement('div');
      dropdown.className = 'custom-dropdown';

      var selected = options.find(function (opt) {
        return opt.selected;
      });

      var isInitialLoad = dropdownWrapper.classList.contains('no-selection');
      // On initial load, show "Please select" regardless of default selection
      var selectedLabel = isInitialLoad ? 'Please select' : selected ? selected.textContent : '';
      var selectedDiv = document.createElement('div');
      selectedDiv.className = 'custom-dropdown__selected';
      selectedDiv.textContent = selectedLabel;
      dropdown.appendChild(selectedDiv);

      var list = document.createElement('ul');
      list.className = 'custom-dropdown__list';
      options.forEach(function (option, idx) {
        var li = document.createElement('li');
        li.className = 'custom-dropdown__option';
        li.textContent = option.textContent;
        li.setAttribute('data-value', option.value);
        if (option.disabled) {
          li.classList.add('custom-dropdown__option--soldout');
          li.setAttribute('aria-disabled', 'true');
        }
        li.addEventListener('click', function (e) {
          if (option.disabled) return;
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          dropdown.classList.remove('open'); // Close dropdown after selection
        });
        list.appendChild(li);
      });
      dropdown.appendChild(list);

      // Toggle list visibility
      selectedDiv.addEventListener('click', function (e) {
        e.stopPropagation();
        dropdown.classList.toggle('open');
      });
      // Close dropdown on outside click
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove('open');
        }
      });

      dropdownWrapper.appendChild(dropdown);

      // Set fixed width after rendering to prevent bold text from changing width
      setTimeout(function () {
        if (initialWidth === null) {
          // First render - calculate width based on longest option text
          var tempDiv = document.createElement('div');
          tempDiv.className = 'custom-dropdown__selected';
          tempDiv.style.position = 'absolute';
          tempDiv.style.visibility = 'hidden';
          tempDiv.style.whiteSpace = 'nowrap';
          document.body.appendChild(tempDiv);

          var maxWidth = 0;
          options.forEach(function (option) {
            tempDiv.textContent = option.textContent;
            maxWidth = Math.max(maxWidth, tempDiv.offsetWidth);
          });

          document.body.removeChild(tempDiv);
          initialWidth = maxWidth + 40; // Add some padding for dropdown arrow and spacing
        }
        // Use the stored initial width for all renders
        dropdown.style.width = initialWidth + 'px';
        dropdown.style.minWidth = initialWidth + 'px';
      }, 0);
    };

    select.renderCustomDropdown();
    select.addEventListener('change', function () {
      dropdownWrapper.classList.remove('no-selection');
      select.renderCustomDropdown();
    });
    dropdownWrapper.addEventListener('forceRerender', function () {
      select.renderCustomDropdown();
    });
  });

  // Helper: Get current selections for all options in order, using correct selector name
  function getCurrentSelections() {
    if (
      !window.productData ||
      !window.productData.options_with_values ||
      !window.productData.product
    )
      return [];
    var optionsWithValues = window.productData.options_with_values;
    var productId = window.productData.product.id;
    var scope = getProductScope();
    // Try to get section id from the first dropdown or swatch.
    // Scoped: a document-wide lookup found the mini cart's upsell swatches first,
    // which yielded the header's section id. Combined with this product's id that
    // produced a selector name matching nothing, so every option read back as
    // "not selected" and every value then looked available - wiping the sold-out
    // strike-throughs the theme had just applied.
    var sectionId = null;
    var firstSelector = scope.querySelector('.product-form__single-selector');
    if (firstSelector && firstSelector.name) {
      var match = firstSelector.name.match(/^(.*)-[0-9]+-[0-9]+$/);
      if (match) sectionId = match[1];
    }
    var selections = [];
    optionsWithValues.forEach(function (option, idx) {
      var optionPosition = option.position || idx + 1;
      var selectorName = sectionId
        ? sectionId + '-' + productId + '-' + optionPosition
        : option.name;
      // Try dropdown first
      var dropdown = scope.querySelector(
        '.product-form__single-selector[name="' + selectorName + '"]'
      );
      if (dropdown && dropdown.tagName === 'SELECT') {
        selections.push(dropdown.value);
        if (document.querySelector('[data-dev-mode]')) {
          console.warn('---Dev Mode Logging---');

          console.log('[Step 3 Debug] Selector', selectorName, 'dropdown value:', dropdown.value);
        }
      } else {
        // Try swatch radio
        var checked = scope.querySelector(
          'input[type="radio"][name="' + selectorName + '"]:checked'
        );
        if (checked) {
          selections.push(checked.value);
          if (document.querySelector('[data-dev-mode]')) {
            console.warn('---Dev Mode Logging---');

            console.log('[Step 3 Debug] Selector', selectorName, 'swatch value:', checked.value);
          }
        } else {
          selections.push(null);
          if (document.querySelector('[data-dev-mode]')) {
            console.warn('---Dev Mode Logging---');

            console.log('[Step 3 Debug] Selector', selectorName, 'no value');
          }
        }
      }
    });
    if (document.querySelector('[data-dev-mode]')) {
      console.warn('---Dev Mode Logging---');

      console.log('[Step 3 Debug] getCurrentSelections:', selections);
    }
    return selections;
  }

  // Step 3: Update disabled states for all dropdowns
  function updateDropdownDisabledStates() {
    // Check if we have the required data
    if (
      !window.productData ||
      !window.productData.product ||
      !window.productData.product.variants
    ) {
      if (document.querySelector('[data-dev-mode]')) {
        console.warn('---Dev Mode Logging---');
        console.warn('[Step 3 Error] Missing product data');
      }
      return;
    }

    const variants = window.productData.product.variants;
    const currentSelections = getCurrentSelections();
    if (document.querySelector('[data-dev-mode]')) {
      console.warn('---Dev Mode Logging---');

      console.log('[Step 3 Debug] getCurrentSelections:', currentSelections);
    }

    // Get all dropdowns (scoped to this product - see getProductScope)
    const scope = getProductScope();
    const dropdowns = scope.querySelectorAll('.custom-variant-dropdown');

    dropdowns.forEach(dropdown => {
      const select = scope.querySelector('[id="' + dropdown.dataset.for + '"]');
      if (!select) return;

      // Get the option position from the select element
      const optionPosition = parseInt(select.dataset.optionPosition) - 1; // Convert to 0-based index
      if (document.querySelector('[data-dev-mode]')) {
        console.warn('---Dev Mode Logging---');

        console.log(`[Step 3 Debug] Processing dropdown at position ${optionPosition}`);
      }

      const options = Array.from(select.options);
      const disabledOptions = [];

      options.forEach(option => {
        const value = option.value;

        // Directional rule: a value is available when the preceding options' selections
        // + this value can form an available variant (following options left free).
        const available = isValueAvailable(variants, currentSelections, optionPosition, value);
        if (document.querySelector('[data-dev-mode]')) {
          console.warn('---Dev Mode Logging---');
          console.log(`[Step 3 Debug] Option ${value} available:`, available);
        }

        if (!available) {
          disabledOptions.push(value);
        }
      });

      if (document.querySelector('[data-dev-mode]')) {
        console.warn('---Dev Mode Logging---');
        console.log('[Step 3 Test] Dropdown', select.id, 'disabled options:', disabledOptions);
      }

      // Update the custom dropdown UI
      const customOptions = dropdown.querySelectorAll('.custom-dropdown__option');
      customOptions.forEach(customOption => {
        const isSoldOut = disabledOptions.includes(customOption.dataset.value);
        customOption.classList.toggle('custom-dropdown__option--soldout', isSoldOut);
        customOption.setAttribute('aria-disabled', isSoldOut);
      });
    });
    if (document.querySelector('[data-dev-mode]')) {
      console.warn('---Dev Mode Logging---');

      console.log('[Step 3 Test] Swatch changed, dropdowns updated');
    }
  }

  // Directional availability, ordered by the option positions configured in Shopify
  // (e.g. colour -> waist -> leg length). A value can be selected when there is an
  // available variant that matches the PRECEDING options' current selections and this
  // value, with the FOLLOWING options left free:
  //   - colour  (1st): available if any available variant has that colour;
  //   - waist   (2nd): available if any available variant has the selected colour +
  //                    that waist (any leg length);
  //   - leg     (3rd): available if the selected colour + waist + that leg is available.
  function isValueAvailable(variants, selections, optionIndex, value) {
    return variants.some(function (variant) {
      for (var i = 0; i <= optionIndex; i++) {
        var target = i === optionIndex ? value : selections[i];
        if (target != null && variant['option' + (i + 1)] !== target) {
          return false;
        }
      }
      return variant.available;
    });
  }

  // Step 3b: Update sold-out state on swatch/block selectors (colour, size, etc.).
  //
  // Uses the directional rule above so each option reflects the selections made before
  // it. We recompute here (rather than relying on the theme) because the theme's own
  // recompute (_updateSelectors) bails out whenever the current option combination has
  // no matching variant, which would otherwise leave the selectors showing stale state.
  function updateSwatchAvailability() {
    if (
      !window.productData ||
      !window.productData.product ||
      !window.productData.product.variants
    ) {
      return;
    }

    var variants = window.productData.product.variants;
    var currentSelections = getCurrentSelections();
    var devMode = document.querySelector('[data-dev-mode]');

    // Scoped to this product: unscoped, this also evaluated the mini cart's upsell
    // swatches against this product's variants and toggled their disabled state.
    getProductScope()
      .querySelectorAll('.color-swatch__radio, .variant-swatch__radio, .block-swatch__radio')
      .forEach(function (input) {
        var optionPosition = parseInt(input.dataset.optionPosition, 10);
        if (isNaN(optionPosition)) return;

        var available = isValueAvailable(
          variants,
          currentSelections,
          optionPosition - 1,
          input.value
        );

        var swatch = input.closest('.block-swatch, .color-swatch, .variant-swatch');
        if (!swatch) return;

        if (swatch.classList.contains('block-swatch')) {
          swatch.classList.toggle('block-swatch--disabled', !available);
        } else if (swatch.classList.contains('color-swatch')) {
          swatch.classList.toggle('color-swatch--disabled', !available);
        } else if (swatch.classList.contains('variant-swatch')) {
          swatch.classList.toggle('variant-swatch--disabled', !available);
        }

        if (devMode) {
          console.warn('---Dev Mode Logging---');
          console.log(
            '[Swatch availability] option',
            optionPosition,
            'value',
            input.value,
            'available:',
            available,
            'selections:',
            currentSelections
          );
        }
      });
  }

  // Recompute every selector's availability (dropdowns + swatches)
  function refreshAvailability() {
    updateDropdownDisabledStates();
    updateSwatchAvailability();
  }

  // Attach event listeners to all variant selectors (dropdowns and swatches)
  var dropdowns = Array.from(document.querySelectorAll('.product-form__single-selector')).filter(
    function (el) {
      return el.tagName === 'SELECT';
    }
  );
  dropdowns.forEach(function (select) {
    select.addEventListener('change', function () {
      document.querySelectorAll('.custom-variant-dropdown').forEach(function (wrapper) {
        var event = new Event('forceRerender');
        wrapper.dispatchEvent(event);
      });
      refreshAvailability();
    });
  });
  // Swatch (color) inputs
  var swatchInputs = document.querySelectorAll(
    '.color-swatch__radio, .variant-swatch__radio, .block-swatch__radio'
  );
  swatchInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      document.querySelectorAll('.custom-variant-dropdown').forEach(function (wrapper) {
        var event = new Event('forceRerender');
        wrapper.dispatchEvent(event);
      });
      refreshAvailability();
      if (document.querySelector('[data-dev-mode]')) {
        console.warn('---Dev Mode Logging---');

        console.log('[Step 3 Test] Swatch changed, dropdowns updated');
      }
    });
  });
  // Initial update on page load. Run synchronously here (not in a setTimeout): the
  // theme applies its selection-based cross-outs during its web-component upgrade,
  // before the first paint, so we must correct to our state before the first paint too —
  // otherwise the sold-out indicators can flash on then off (FOUC).
  refreshAvailability();

  // Belt-and-braces: a delegated listener on the document catches every variant
  // selector change even if the direct listeners above missed an element (e.g. it was
  // re-rendered). Scheduled as a microtask (not setTimeout) so it runs AFTER the theme's
  // own synchronous change handler but still BEFORE the browser paints — this keeps the
  // final state correct without a flash of the sold-out indicators.
  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest('.product-form__option')) {
      queueMicrotask(refreshAvailability);
    }
  });

  // Also refresh whenever the theme resolves (or fails to resolve) a variant.
  document.addEventListener('variant:changed', function () {
    document.querySelectorAll('.custom-variant-dropdown').forEach(function (wrapper) {
      wrapper.dispatchEvent(new Event('forceRerender'));
    });
    queueMicrotask(refreshAvailability);
  });
});

// Stock message: reflect the selected variant's dispatch/availability in the
// shipping-time block. In-stock (client-held) variants show the despatch message,
// backordered variants show "Ships {shipping_time}", unavailable shows "Sold Out".
// The per-variant messages are rendered server-side (see snippets/stock-message.liquid).
(function () {
  function getMessagesMap() {
    var container = document.querySelector('[data-stock-area]');
    var el = container && container.querySelector('[data-stock-messages]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function updateStockMessage(variant) {
    var container = document.querySelector('[data-stock-area]');
    if (!container) return;
    var messageEl = container.querySelector('[data-stock-message]');
    if (!messageEl) return;

    var map = getMessagesMap();
    var entry = variant && map ? map[variant.id] : null;

    if (entry) {
      messageEl.textContent = entry.message;
      container.classList.toggle('product-meta__shipping-time--sold-out', !!entry.soldOut);
    } else if (!variant) {
      // No matching variant (invalid combination) — treat as sold out
      var soldOutLabel = container.getAttribute('data-soldout-label');
      if (soldOutLabel) messageEl.textContent = soldOutLabel;
      container.classList.add('product-meta__shipping-time--sold-out');
    } else {
      // Fallback: no per-variant data on the page, keep the server-rendered text
      container.classList.toggle('product-meta__shipping-time--sold-out', !variant.available);
    }
  }

  // Update whenever the variant changes (variant is null for an unavailable combination)
  document.addEventListener('variant:changed', function (event) {
    updateStockMessage(event.detail && event.detail.variant);
  });

  // Read the page's own product JSON rather than relying on `window.productData`
  // having been populated (and populated from the right script) by the time this
  // runs.
  function getInitialVariant() {
    var script = getProductJsonScript();
    if (!script) return null;

    var data;
    try {
      data = JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }

    if (!data || !data.product) return null;

    return (
      (data.product.variants || []).find(function (v) {
        return v.id === data.selected_variant_id;
      }) || null
    );
  }

  // Set the correct initial state on page load
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('[data-stock-area]')) return;

    var variant = getInitialVariant();

    // If we cannot work out which variant is selected, leave the server-rendered
    // message alone - it is already correct for the selected variant. Forcing
    // the sold-out copy here is only right in response to the shopper picking an
    // unavailable combination, which `variant:changed` covers.
    if (!variant) return;

    updateStockMessage(variant);
  });
})();

// reviews.io

const jumpToReviewsIO = () => {
  const links = document.querySelectorAll('.product-block-list__tabs_navigation > ul > li > a');
  if (links.length > 0) {
    // is product reviews selected, click it!
    if (!links[links.length - 1].classList.contains('selected')) {
      links[links.length - 1].click();
    }
    const target = document.getElementById('product-reviews-io');
    if (target) {
      window.scrollTo({
        top: target.offsetTop,
        behavior: 'smooth'
      });
    }
  }
};

document.querySelectorAll('.ruk_rating_snippet, .ruk_read_reviews').forEach(element => {
  element.addEventListener('click', event => {
    event.preventDefault();
    jumpToReviewsIO();
  });
});

document.querySelectorAll('.ruk_read_reviews').forEach(element => {
  element.addEventListener('click', event => {
    event.preventDefault();
    jumpToReviewsIO();
  });
});

// Function to show the tooltip
function showTooltip(event) {
  const tooltipText = event.target.getAttribute('data-tooltip');

  if (!tooltipText) return;

  // Create tooltip element
  const tooltip = document.createElement('div');
  tooltip.className = 'img-tooltip';
  tooltip.textContent = tooltipText;

  document.body.appendChild(tooltip);

  const targetRect = event.target.getBoundingClientRect();
  const tooltipRect = tooltip.getBoundingClientRect();

  // Scroll position
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // Position the tooltip above the element
  tooltip.style.left = `${targetRect.left + targetRect.width / 2 - tooltipRect.width / 2 + scrollLeft}px`;
  tooltip.style.top = `${targetRect.top + (targetRect.height + 10) + scrollTop}px`;

  // Show tooltip
  tooltip.classList.add('img-tooltip-visible');

  // Store the tooltip element on the target element for future reference
  event.target._tooltipElement = tooltip;
}

// Function to hide the tooltip
function hideTooltip(event) {
  const tooltip = event.target._tooltipElement;
  if (tooltip) {
    tooltip.remove(); // Remove the tooltip from the DOM
    event.target._tooltipElement = null;
  }
}

const uniqueAlts = [
  ...new Set(
    Array.from(document.querySelectorAll('.product-gallery__thumbnail')).map(element => {
      const img = element.querySelector('img');
      return img ? img.getAttribute('alt') : '';
    })
  )
];

document.querySelectorAll('.product-gallery__thumbnail').forEach(element => {
  const img = element.querySelector('img');
  if (img && uniqueAlts.length > 1) {
    img.setAttribute('data-tooltip', img.getAttribute('alt'));
    // img.classList.add("tooltip-trigger");
  }
});

// Attach event listeners to the tooltip triggers
document.querySelectorAll('.tooltip-trigger').forEach(trigger => {
  trigger.addEventListener('mouseenter', showTooltip);
  trigger.addEventListener('mouseleave', hideTooltip);
});

// const checkPdpRefferer = () => {
//   // Get the query string from the referrer
//   const referrerQueryString = document.referrer.split('?')[1] || '';
//   if (!referrerQueryString) return;
//   // Split the query string into an array
//   const splitString = referrerQueryString.split('&');
//   // Get all the product options
//   const productOptions = document.querySelectorAll('.product-form__option');
//   // Loop through all the product options
//   productOptions.forEach(productOption => {
//     // Get the option name and the selectors
//     const optionName = productOption
//       .querySelector('.product-form__option-name')
//       .childNodes[0].nodeValue.replace(':', '')
//       .toLowerCase()
//       .trim();
//     const optionSelectors = productOption.querySelectorAll('.product-form__single-selector');

//     // We need to compare the option name to the query string
//     // Then get the relevant value and select it
//     splitString.forEach(queryString => {
//       // Split the query string into an array
//       const query = queryString.split('=');
//       // Size and Colour need remapping
//       const facetName = query[0]
//         .toLowerCase()
//         .replace('custom_clothing_size', 'size')
//         .replace('custom_colour', 'colour');

//       // Check if the query string matches the option name
//       if (facetName === optionName) {
//         // Get the option value
//         const optionValue = query[1];

//         // Loop through all the selectors and select the option
//         optionSelectors.forEach(optionSelector => {
//           if (optionSelector.nodeName === 'SELECT') {
//             optionSelector.value = optionValue;
//           } else if (optionSelector.nodeName === 'INPUT') {
//             // Check if the option selector matches the option value
//             if (optionSelector.dataset.handle === optionValue) {
//               // Click the label
//               optionSelector.nextElementSibling.click();
//             }
//           }
//         });
//       }
//     });
//   });
// };
// if (window.location.href.includes('product')) {
//   checkPdpRefferer();
// }

// Step 2: Utility function to check if an option value is available for the current selection
function isOptionAvailable(variants, currentSelections, optionIndex, value) {
  // Create a test selection array that uses the current selections but replaces the option being tested
  const testSelections = [...currentSelections];
  testSelections[optionIndex] = value;

  // Check if any variant matches this combination and is available
  return variants.some(function (variant) {
    // Check if this variant matches our test selections
    const matches = testSelections.every((selection, index) => {
      // If we have a selection for this index, check if it matches
      if (selection != null) {
        return variant['option' + (index + 1)] === selection;
      }
      // If no selection, consider it a match
      return true;
    });

    // Only return true if the variant matches AND is available
    return matches && variant.available;
  });
}

// Step 2 Test: Example usage (run in console to verify)
document.addEventListener('DOMContentLoaded', function () {
  if (window.productData && window.productData.product && window.productData.product.variants) {
    var variants = window.productData.product.variants;
    // Example: Check if 'M - 39.5-41" Chest' is available for option2 when option1 is 'Deep Fjord'
    var test1 = isOptionAvailable(variants, ['Deep Fjord', null], 1, 'M - 39.5-41" Chest');
    var test2 = isOptionAvailable(variants, ['Patrol Orange', null], 1, 'XL - 44-47" Chest');
    var test3 = isOptionAvailable(variants, ['Olive Green', null], 1, 'XL - 44-47" Chest');
    if (document.querySelector('[data-dev-mode]')) {
      console.warn('---Dev Mode Logging---');

      console.log('[Step 2 Test] Deep Fjord + M:', test1); // Should be false if unavailable
      console.log('[Step 2 Test] Patrol Orange + XL:', test2); // Should be true if available
      console.log('[Step 2 Test] Olive Green + XL:', test3); // Should be false if unavailable
    }
  }
});
